export const MetaHubCommands = {
    registerByRequestId: 'registerByRequestId',
    unRegisterByRequstId: 'unRegisterByRequestId',
}

export const MetaHubEvents = {
    handpickChangesReady: 'HandpickChangesReady',
    handpickChangeNotification: 'HandpickChangeNotification'
}
